import { useEffect, useState } from "react";
import {
  WorkOrderActivity,
  WorkOrderMetadata,
} from "../models/workorders/WorkOrder";
import { getColumnsWithGroup } from "../api/Windows";
import "./WOApprovalModal.css";
import ApprovalLogActivityComp from "./ApprovalLogActivityComp";

interface LogActivityDisplay {
  isOpen: boolean;
  dismiss: () => void;
  setShowLoading: (showLoading: boolean) => void;
  poActivity: WorkOrderActivity[];
}

// US 806719 - PO approval log activity. Mirrors WOApprovalLogActivity but
// reads the PO approval log window metadata. The activity rows share the
// WorkOrderActivity shape, so the generic ApprovalLogActivityComp renders them.
const POApprovalLogActivity: React.FC<LogActivityDisplay> = (props) => {
  const { isOpen, dismiss, setShowLoading, poActivity } = props;
  const [metadata, setMetadata] = useState<WorkOrderMetadata>();

  const logActivityMetadata = async () => {
    setShowLoading(true);
    // Reuse the shared approval-log window (as RequisitionApproval does): the
    // log rows are generic wo_log_activity.* fields, so no PO-specific log
    // window is needed.
    const data = {
      WindowName: "mob_wo_approvals_log",
      IncludeValidValues: true,
    };
    return getColumnsWithGroup(data).then((response) => {
      setMetadata(response.data);
      setShowLoading(false);
    });
  };

  useEffect(() => {
    logActivityMetadata();
  }, []);

  return (
    <>
      {metadata && (
        <ApprovalLogActivityComp
          isOpen={isOpen}
          dismiss={dismiss}
          activity={poActivity}
          metadata={metadata}
        />
      )}
    </>
  );
};

export default POApprovalLogActivity;
